import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  { title: 'Admin', isLink: false },
  { title: 'Follow Up Status', href: '/admin/follow-up-status' },
  {
    title: 'Follow Up Status',
    prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
  },
];

const Title: PageTitle = {
  title: 'Follow Up Status',
  prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };
